<template>
    <div>
        <div class="container">
            <div class="row justify-center">
                <div class="col-xs-12 col-md-6">
                    <div class="text-title row items-center"><q-icon name="mdi-lock-reset" size="2rem" class="q-mr-xs" />Password Recovery</div>

                    <div v-if="!showConfirm">
                        <p v-if="expired" class="text-negative">Your password reset link has expired and is no longer valid.</p>
                        <p v-if="expired">Please enter your account email to receive a new password reset link and follow the instructions provided.</p>
                        <p v-else>Forgot your password? We can help you reset your password. First, enter your account email and follow the instructions provided.</p>
                        <q-form @submit="onSubmit" autocomplete="off">
                            <div class="q-gutter-y-md column">

                                <q-input v-model.trim="form.email"
                                         label="Recovery Email"
                                         autocomplete="on" name="email"
                                         :rules="[ val => $v.form.email.required || 'Recovery email is required', val => $v.form.email.email || 'Not a valid email format'  ]"
                                         outlined dense
                                         hide-bottom-space>
                                    <template v-slot:prepend>
                                        <q-icon name="mdi-email" />
                                    </template>
                                </q-input>
                                <div class="row q-col-gutter-sm q-mt-sm">
                                    <div class="col-xs-12 col-sm-auto">
                                        <q-btn color="primary"
                                               label="Continue"
                                               type="submit"
                                               class="full-width" />
                                    </div>
                                    <div v-if="autoActivationMode" class="col-xs-12 col-sm-auto">
                                        <q-btn label="Back" @click="$emit('back')" color="primary" flat class="full-width" />
                                    </div>
                                </div>
                            </div>
                            <q-inner-loading :showing="forgotPasswordPending">
                                <div>
                                    <q-spinner color="primary"
                                               :thickness="2"
                                               size="3em" />
                                </div>
                            </q-inner-loading>
                        </q-form>
                    </div>
                    <div v-else>
                        <p>We have received your request. If the email you have provided is in our system, we will send you a link to reset your password shortly. Please check your email for further instructions.</p>
                        <div class="row">
                            <q-btn v-if="!autoActivationMode" label="Return To Login" color="primary" class="col-xs-12 col-sm-auto" @click="returnToLogin" />
                            <q-btn v-else label="Login" color="primary" class="col-xs-12 col-sm-auto" @click="$emit('login')" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, email } from 'vuelidate/lib/validators'
    import { mapState } from 'vuex'

    export default {
        name: 'forgot-pass',
        props: {
            autoActivationMode: {
                default: false,
                type: Boolean
            },
            returnUrl: {
                default: '',
                type: String
            },
        },
        data() {
            return {
                expired: false,
                showConfirm: false,
                form: {
                    email: '',
                }
            }
        },
        validations: {
            form: {
                email: { required, email },
            }
        },
        computed: {
            ...mapState([
                'forgotPasswordPending',
                'forgotPasswordData',
            ]),
        },
        methods: {
            forgotPassword() {
                const payload = { email: this.form.email, returnUrl: this.returnUrl }
                this.$store.dispatch('forgotPassword', payload).then(() => {
                    this.showConfirm = true
                })

            },
            onSubmit() {
                this.$v.form.$touch()
                if (this.$v.form.$pending || this.$v.form.$error) return
                this.forgotPassword()
            },
            returnToLogin() {
                if (this.returnUrl) {
                    this.$router.push({
                        path: this.returnUrl,
                        query: { login: true },
                    }).then(() => {
                        window.location.reload();
                    });
                }
                else {
                    this.$router.push({
                        path: '/',
                        query: { login: true },
                    }).then(() => {
                        window.location.reload();
                    });
                }

            },
        },
        created() {
            this.expired = this.$route.query.expired || false;
        },
        watch: {
            '$route.query.expired'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.expired = newVal
                }
            },
        },
    }
</script>
